var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"toast"},[_vm._v("复制成功")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }